export default {
    'OPERACION_FINALIZADO': (state, mutation) => {
        state.finalizado = mutation.finalizado
    }
}